export default __webpack_public_path__ + "locales/si/SingleSignOn.json?hash=29387aced5b1b7320d2eed925b005381";